import axios from 'axios';
import {api} from '../../constants/api';
import {actions as A} from '../../../Inspection/constants/actions';
import {errors as E} from 'common/constants/errors';

export const getFileList = ({shumaId}) => dispatch => {
  const data = {shumaID: parseInt(shumaId, 10)};

  dispatch({
    type: A.GET_STEP_11_FILE_LIST,
  });

  return axios.post(api.GET_FILE_LIST, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      dispatch({
        type: A.GET_STEP_11_FILE_LIST_SUCCESS,
        payload: {list: body.fileList},
      });

      return body.fileList;
    })
    .catch((err) => {
      dispatch({
        type: A.GET_STEP_11_FILE_LIST_SUCCESS,
        payload: {errorMessage: err.message},
      });
    });
};
